const fire = maybeRun('fire')

const getContent = maybeRun('getContent')

const focus = maybeRun('focus')

// `keepParagraphs` signals content-cleanup plugins (groove-before-set-content-cleanup)
// to keep <p> as <p> for this write. TinyMCE 4's insertContent doesn't forward
// custom event args, so we flag the editor instance around the synchronous
// insert/set call (BeforeSetContent fires within it) and clear it after.
const withKeepParagraphs = (editor, options, run) => {
  const keep = !!(options && options.keepParagraphs)
  if (keep) editor.helplyKeepParagraphs = true
  try {
    return run()
  } finally {
    if (keep) editor.helplyKeepParagraphs = false
  }
}

const insertContent = (content, options) => {
  const editor = getEditor()
  if (!editor) return false
  const result = withKeepParagraphs(editor, options, () =>
    editor.insertContent(content)
  )
  if (options && options.focus) editor.focus()
  return result
}

const setContent = (content, options) => {
  const editor = getEditor()
  if (!editor) return false
  const result = withKeepParagraphs(editor, options, () =>
    editor.setContent(content)
  )
  if (options && options.focus) editor.focus()
  return result
}

function getEditor(name = null) {
  const tiny = getTiny()
  if (!tiny) return undefined
  if (name) return tiny.get(name)
  return tiny.activeEditor
}

function getTiny() {
  if (typeof window === 'undefined') return undefined
  return window.tinyMCE
}

function maybeRun(fnName) {
  return (...args) => {
    const editor = getEditor()
    if (!editor) return false
    return editor[fnName](...args)
  }
}

function isTextSelected(editor) {
  return !!(editor.selection && !editor.selection.isCollapsed())
}

export default {
  fire,
  getContent,
  insertContent,
  setContent,
  focus,
  getEditor,
  isTextSelected,
  COMPOSER_ID: 'composer-editor',
}
